export default __webpack_public_path__ + "static/media/48.ff13d6f4.png";